module.exports = __webpack_public_path__ + "img/thank_you_page.ca17d40c.gif";